import React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import GridViewIcon from '@mui/icons-material/GridView';
import HtmlIcon from '@mui/icons-material/Html';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import ClosedCaptionOffIcon from '@mui/icons-material/ClosedCaptionOff';

import VENewComponentDialog from './VENewComponentDialog';

export default function VENewElement(props) {

    const [selectedElementType, setSelectedElementType] = React.useState(null);
    const [typeDescription, setTypeDescription] = React.useState("");

    const [newElementDialogOpen, setNewElementDialogOpen] = React.useState(true);
    const [newComponentDialogOpen, setNewComponentDialogOpen] = React.useState(false);

    const elementTypes = [
        {
            name: "Video",
            description: "Adds a video element to the scene/movie and allows you to control the playback of the video.",
            type: "video",
            icon: <OndemandVideoIcon sx={{ fontSize: "50px" }} />
        },
        {
            name: "Image",
            description: "Adds an image element to the scene/movie and allows you to control display properties of the image.",
            type: "image",
            icon: <PhotoCameraIcon sx={{ fontSize: "50px" }} />
        },
        {
            name: "Text",
            description: "Adds a text element to the scene/movie and allows you to control display properties of the text, including the text animation, font family, size, etc.",
            type: "text",
            icon: <TextFieldsIcon sx={{ fontSize: "50px" }} />
        },
        {
            name: "Component",
            description: "Adds a component element to the scene/movie and allows you to control display properties and behaviour of the component.",
            type: "component",
            icon: <GridViewIcon sx={{ fontSize: "50px" }} />
        },
        {
            name: "HTML",
            description: "Adds an HTML element to the scene/movie and allows you to set the HTML5 and CSS3 code.",
            type: "html",
            icon: <HtmlIcon sx={{ fontSize: "50px" }} />
        },
        {
            name: "Audio",
            description: "Adds an audio element to the scene/movie and allows you to control playback of the audio.",
            type: "audio",
            icon: <AudioFileIcon sx={{ fontSize: "50px" }} />
        },
        {
            name: "Voice",
            description: "Adds a voice element to the scene/movie and allows you to control language, style of voice and the text to speak.",
            type: "voice",
            icon: <ChatBubbleOutlineIcon sx={{ fontSize: "50px" }} />
        },
        {
            name: "Audiogram",
            description: "Adds an audiogram element to the scene/movie that visualizes the audio as a waveform.",
            type: "audiogram",
            icon: <GraphicEqIcon sx={{ fontSize: "50px" }} />
        }, {
            name: "Subtitles",
            description: "Adds a subtitles element to the scene/movie that displays subtitles transcribed from the voice-over audio.",
            type: "subtitles",
            icon: <ClosedCaptionOffIcon sx={{ fontSize: "50px" }} />
        }
    ];

    return (
        <>
            <Dialog open={newElementDialogOpen} fullWidth={true} maxWidth="md" onClose={handleClose} scroll="paper">
                <DialogTitle><span className="font-bold">Add a new element</span></DialogTitle>
                <DialogContent dividers={true}>
                    <Box className="flex">
                        <Box className="w-2/3 flex flex-wrap gap-2">
                            {
                                elementTypes.map((elementType, index) => {
                                    let itemClasses = "w-32 h-32 flex flex-col justify-center border border-gray-200 rounded-lg hover:border-4 hover:bg-gray-50 cursor-pointer";
                                    if (elementType.type === selectedElementType) {
                                        itemClasses = "w-32 h-32 flex flex-col justify-center bg-blue-200 border-4 border-blue-400 rounded-lg cursor-pointer";
                                    }
                                    
                                    return (
                                        <Box key={elementType.type} datatype={elementType.type} className={itemClasses} onClick={handleTypeClick}>
                                            <Box className="text-center">{elementType.icon}</Box>
                                            <Box className="text-center">{elementType.name}</Box>
                                        </Box>
                                    );
                                })
                            }
                        </Box>
                        <Box className="w-1/3">
                            <p className="font-bold">Description</p>
                            <p>{typeDescription}</p>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleAddElement}>Add</Button>
                </DialogActions>
            </Dialog>
            {
                newComponentDialogOpen &&
                <VENewComponentDialog elementType={selectedElementType} onClose={handleNewComponentDialogClose} />
            }
        </>
    );

    function handleTypeClick(event) {
        const clickedElementType = event.currentTarget.getAttribute("datatype");
        setSelectedElementType(clickedElementType);

        const typeDescription = elementTypes.find((elementType) => elementType.type === clickedElementType).description;
        setTypeDescription(typeDescription);
    }

    function handleClose(event) {
        props.onClose(null);
    }

    function handleAddElement(event) {
        console.log("Add element: ", selectedElementType);
        if (["component", "text"].includes(selectedElementType)) {
            setNewElementDialogOpen(false);
            setNewComponentDialogOpen(true);
        }
        else {
            props.onClose(selectedElementType);
        }
    }

    function handleNewComponentDialogClose(response) {
        setNewComponentDialogOpen(false);
        setNewElementDialogOpen(true);
        props.onClose(response);
    }
}